/**
 * 角色管理服务
 */

import { httpClient } from './httpClient';
import { API_ENDPOINTS } from './api/config';

export const roleService = {
  async getList(params: any) {
    return httpClient.get(API_ENDPOINTS.ROLE.LIST, { params });
  },
  
  async getById(id: number) {
    return httpClient.get(`${API_ENDPOINTS.ROLE.DETAIL}/${id}`);
  },
  
  async create(data: any) {
    return httpClient.post(API_ENDPOINTS.ROLE.CREATE, data);
  },
  
  async update(data: any) {
    return httpClient.put(API_ENDPOINTS.ROLE.UPDATE, data);
  },
  
  async delete(id: number) {
    return httpClient.delete(`${API_ENDPOINTS.ROLE.DELETE}/${id}`);
  },
  
  async batchDelete(ids: number[]) {
    return httpClient.delete(`${API_ENDPOINTS.ROLE.DELETE}/batch`, { data: ids });
  }
};

export default roleService;






































